import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const features = ['6 módulos completos', '6 bonos incluidos', 'Formato PDF digital', 'Acceso desde celular o computadora'];
  return <section id="precio" className="py-24 px-4 bg-forest relative overflow-hidden" data-id="element-120">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-sage via-forest to-forest" data-id="element-121"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-122">
        <div className="text-center mb-12" data-id="element-123">
          <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-124">
            OFERTA DISPONIBLE HOY
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream" data-id="element-125">
            Acceso inmediato al sistema completo
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-warm-white rounded-3xl p-8 md:p-12 shadow-warm-lg max-w-2xl mx-auto relative border-4 border-sage/20" data-id="element-126">
          {/* Ribbon */}
          <div className="absolute -top-5 -right-5 md:-right-8 bg-terracotta text-white font-bold py-2 px-6 rounded-full shadow-lg transform rotate-3 border-2 border-white" data-id="element-127">
            OFERTA -50%
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-10" data-id="element-128">
            <div data-id="element-129">
              <ul className="space-y-4" data-id="element-130">
                {features.map((feat, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-131">
                    <CheckCircle2 className="w-6 h-6 text-sage flex-shrink-0" data-id="element-132" />
                    <span className="text-charcoal font-medium" data-id="element-133">{feat}</span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center md:text-right border-t md:border-t-0 md:border-l border-sage/20 pt-8 md:pt-0 md:pl-8" data-id="element-134">
              <span className="text-terracotta font-bold text-sm tracking-widest uppercase block mb-2" data-id="element-135">
                PRECIO ESPECIAL
              </span>
              <div className="text-muted line-through text-2xl font-serif mb-1" data-id="element-136">
                AR$ 39.990
              </div>
              <div className="text-forest text-5xl md:text-6xl font-serif font-bold mb-3" data-id="element-137">
                AR$ 19.990
              </div>
              <div className="text-sm font-medium text-charcoal bg-sage/10 inline-block px-3 py-1 rounded-full mb-2" data-id="element-138">
                Pago único · Acceso de por vida
              </div>
              <div className="text-sm text-terracotta font-bold" data-id="element-139">
                Pesos argentinos · Ahorrás más del 50% hoy
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-140">
            <Button href="https://checkout.equilibriodigital.shop/cart/47582420140222:1" target="_blank" rel="noopener noreferrer" className="w-full py-5 text-xl mb-4 shadow-lg hover:shadow-xl" data-id="element-141">
              QUIERO MEJORAR MI ALIMENTACIÓN HOY
            </Button>
            <div className="flex items-center justify-center gap-2 text-sm text-muted font-medium" data-id="element-142">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-143" />
              Pago seguro Mercado Pago · Acceso inmediato
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}